module.exports = __webpack_public_path__ + "static/media/galerija_2022_0037.18b5d542.jpg";